import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import { IReturnComplaintAttachment } from './usePostReturnComplaintAttachment';

interface IResponse {
  items: IReturnComplaintAttachment[];
  total_count: number;
  total_pages: number;
  page: number;
}

const getReturnComplaintAttachments = (complaintId: number): Promise<IResponse> =>
  axios.get(`/panel/return-complain/requests/${complaintId}/attachments`);

export const useGetReturnComplaintAttachments = (
  complaintId: number,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['return-complain-attachments', complaintId],
    () => getReturnComplaintAttachments(complaintId),
    options
  );
